/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Placeholder_4Inputs */

const en_try_magic_placeholder_4 = /** @type {(inputs: Try_Magic_Placeholder_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Express yourself...`)
};

const es_try_magic_placeholder_4 = /** @type {(inputs: Try_Magic_Placeholder_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exprésate...`)
};

/**
* | output |
* | --- |
* | "Express yourself..." |
*
* @param {Try_Magic_Placeholder_4Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_placeholder_4 = /** @type {((inputs?: Try_Magic_Placeholder_4Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Placeholder_4Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_placeholder_4(inputs)
	return en_try_magic_placeholder_4(inputs)
});